import { createPinia } from 'pinia'
import { createApp } from 'vue'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import App from '../App.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

const storeApp = createApp(App)
storeApp.use(pinia)

export default pinia
